import type { PresentationIsEmptyProps } from '../../'
export default function isEmpty({ block, isPrint }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  if (!fields.image) {
    return true
  }

  if (isPrint && fields.image.format === 'youtube') {
    return true
  }

  return false
}
